import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MenuItemModel, TenantConfig } from 'brain-data/model/config.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

export const TENANT_URL = `${environment.apiBaseUrl}/tenants`;

const brainToUppercase = (text: string | undefined): string => (text ?? '').replace(/Brain/g, 'BRAIN');

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private http: HttpClient) {}

  getTenantConfig(): Observable<TenantConfig> {
    return this.http.get<TenantConfig>(`${TENANT_URL}/tenant-configs/ui`).pipe(map(config => this.normalizeBrainLabels(config)));
  }

  private normalizeBrainLabels(config: TenantConfig): TenantConfig {
    if (!config?.data?.menuItems) {
      return config;
    }
    const menuItems: MenuItemModel[] = config.data.menuItems.map(item => ({
      ...item,
      text: brainToUppercase(item.text),
      subItems: item.subItems?.map(sub => ({ ...sub, text: brainToUppercase(sub.text) })),
    }));
    return { ...config, data: { ...config.data, menuItems } };
  }
}
